<template>
    <div id="app">
        <h2 style="text-align:center">隐私政策</h2>
        <p>开发者：湖北才优科技有限公司</p>
        <p>本隐私政策生效日期：2023年11月16日</p>
        <p>最近更新日期：2023年11月16日</p>
        <div style="font-weight: 600; text-decoration:underline;text-indent:2em">
            【特别提示】请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本《隐私政策》。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。
            如对本隐私政策有任何疑问，您可以通过本隐私政策“如何联系我们”中提供的方式与我们联系）。
        </div>
        <p>欢迎您使用“小蜜蜂兼职”平台，（以下简称“平台”）由湖北才优科技有限公司（以下简称“我们“）开发及管理，我们对每一位用户的隐私权都采取高度尊重且保护的态度，我们及关联公司就向您提供的服务设立隐私权政策，以保障您的隐私信息不被恶意泄露。</p>
        <p>本政策适用于我们提供的所有服务，但不适用于其它第三方向您提供的服务，也不适用在我们平台中另行独立设置隐私权政策的服务。如平台上的第三方向您提供服务，您向第三方提供的个人信息不适用本政策。如您对本隐私权政策有任何异议或意见，您均可与我们联系。</p>
        <p>您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本政策向您说明，我们如何取得、使用、分享、保存和管理这些信息。 请在使用我们的各项服务前，仔细阅读并充分理解本政策（尤其是加粗提示的内容），并在需要时按照本政策的指引作出适当的选择。如果您不同意本政策的内容，您应立即停止使用我们的服务。 您使用或继续使用我们提供的服务的行为，都表示您充分理解和同意本《隐私政策》（包括更新版本）的全部内容。</p>
        <h4>第一条 定义</h4>
        <p>·1.1 小蜜蜂兼职平台：指包括小蜜蜂兼职网站（域名https://www.xxzcyjz.com）、 “小蜜蜂兼职”手机端APP、微信端小程序、支付宝小程序、支付宝嵌入页等网站及客户端、小程序。（以下简称“平台”）。</p>
        <p>·1.2 平台提供方：指湖北才优科技有限公司及其关联公司。</p>
        <p>·1.3 平台规则：所有在平台内已发布的及后续发布的全部规则、公告、解释等内容。</p>
        <h4>第二条 我们如何收集您的个人信息</h4>
        <p>·2.1 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息， 我们可能收集的个人信息包括您的姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、账号密码、健康生理信息、交易信息、在读院校信息、个人档案等。</p>
        <p>·2.2 我们向您收集的个人信息及设备信息</p>
        <p>·2.2.1 为使用平台服务，您首先需要注册并提供相关信息，如果您是兼职自然人，您需要提供您的姓名、电子邮箱地址、创建的用户名和密码、性别、学校、头像、联系方式、个人档案等。如果您是商户，您需提供您的名称、电子邮箱地址、创建的账户名和密码、营业执照、联系方式、相关资质许可文件等以便我们进行核验，同时我们将建立商户信息登记档案，并定期核验更新。如果您授权使用第三方账号登陆，我们会从第三方获取您共享的账号信息，并将您的第三方账户与小蜜蜂兼职账户进行绑定。如您拒绝提供相应信息，您将无法正常使用我们的服务；</p>
        <p>·2.2.2 您注册成为用户后，如果您是兼职人员，我们将根据您的注册信息，向您推荐招聘企业、企业活动等，并由您自行判定是否最终达成兼职活动。如果您是商户，您有权在我们的平台发布相应的兼职招聘信息，并推送给兼职人员 ，但您发布的信息需要符合我们的形式标准，否则我们有权修改非实质性招聘信息（实质性信息包括：工作时间、工作报酬、工作地点、对兼职人员的特别限制条件）。</p>
        <p>·2.2.3 当您使用我们的服务时，我们将收集您所使用的相关设备信息，以便为您提供持续稳定的服务支持（如数据的实时同步等）， 同时有助于我们不断改善自身服务，从而使您在使用我们服务过程中获得最优体验。我们收集的您所使用的相关设备信息包括设备名称、设备型号、硬件序列号、操作系统和应用程序版本及类型、语言设置、分辨率、移动终端随机存储内存、登录IP地址、接入网络的方式、 网络质量数据、移动网络信息（包括运营商名称）、日志信息（如操作日志、服务日志）等。</p>
        <p>·2.3 第三方向您收集的信息</p>
        <p>·2.3.1 我们在提供服务过程中，将涉及交易对方提取您相关个人信息的情况，在此情况下，您应当允许我们向交易对方提供与您交易所需的个人信息。</p>
        <p>·2.3.2 我们可能会与第三方服务机构合作，在我们平台或线下服务为您接入第三方服务（例如投放广告、链接或者其它形式的推广内容），我们不会将您提供给我们的个人信息 （如手机号码、头像等） 与第三方服务商共享，也不会代表第三方服务商为其收集您的个人信息。通过我们服务接入的第三方服务商可能有自己的隐私权政策，其不受本《隐私权政策》的约束。 第三方服务提供商可能会根据其自己的隐私权政策收集为您提供服务所需的个人信息，我们将尽合理的努力要求第三方服务商在处理您的个人信息时遵守相关法律法规，尽力要求其采取相关的保密和安全措施，但我们无法保证其一定会按照我们提出的要求采取相应措施，还请您审慎选择。</p>
        <p>·2.3.3 获取权限以为您提供其他附加服务</p>
        <p style="font-weight:600">我们的产品基于idea开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM卡IMSI信息、OAID、剪切板）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。</p>
        <p style="font-weight:600">为向您提供更便捷、更优质的服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集、缓存和使用您的个人信息及应用权限。如果您不提供这些信息或权限，不会影响您使用小蜜蜂兼职的浏览、搜索基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务及所需权限包括：</p>
        <p>1、定位权限：我们会在您开启位置权限后访问获取您大致的位置信息，向您推荐附近的工作或者职位等相关信息。</p>
        <p>2、相机权限：用于在您上传头像图片或其他文件时，使用相机权限拍照并上传相应文件。</p>
        <p>3、相册权限：用于在您上传头像图片或其他文件时，使用相册权限上传相应文件和图片同时保存相应文件和图片到相册。</p>
        <p>4、读写手机存储权限：您可以在开启存储权限后，使用该功能以实现数据缓存、分享或与客服沟通提供证明功能。</p>
        <p>5、基于读取手机状态和身份信息的附加服务：我们将在您开启电话权限后收集您的iOS广告标识符（IDFA）、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI），根据您的设备确认您的账户安全，实现安全风控。</p>
        <p>6、录音权限：可能会使用该权限以验证您的身份。</p>
        <p>7、唤醒第三方APP：此功能可以使您在浏览小蜜蜂兼职商品、服务时跳转到第三方APP的指定页面。</p>
        <p>8、读取日历权限：在您开启我们可读取/写入您日历的权限后，我们将收集您的日历信息用于向您提供购物或领取权益相关记录及提醒。</p>
        <p>9、应用信息推送服务：我们可能会为您提供程序化推送信息、服务。为了向您提供更高效更优质的服务体验。</p>
        <p>10、系统运营信息：为您提供终端用户服务的兼容性处理，我们会获取：系统运营信息</p>
        <p>11、网络状态信息：基于我们对网络链路的选择与优化，我们会获取：网络状态信息；</p>
        <p>12、基站信息：基于我们为检测不同区域的服务，我们会获取：基站信息。</p>
        <p>13、剪切板权限：调用您的剪切板功能在您分享或者被分享、参加活动的场景下，小蜜蜂兼职客户端需要读取您的剪切板信息，使用目的为读取其中包含的口令、链接，以实现跳转、分享、活动联动功能。我们在本地识别出小蜜蜂兼职功能有关的剪切板内容时，会将其上传至服务器。剪切板信息属于该功能的必须信息。 其他信息： 我们可能会收集其他必要的信息，如设备状态、网络连接类型等，但这些信息仅用于优化服务体验，不会用于任何未经授权的目的。</p>
        <p>14、应用自启动：为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的沟通聊天广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p>
        <p>15、个性化定向推荐：个性化定向推荐是指根据用户的行为、偏好或兴趣来给用户提供个性化的相关岗位内容推荐。</p>
        <p>16、后台收集: 在某些情况下，当您在后台使用或静默状态下运行本应用时，我们可能会收集以下信息：安装、卸载和更新应用信息： 我们的应用会监听系统广播（如PACKAGE_REMOVED、PACKAGE_REPLACED、PACKAGE_ADDED），以确保应用的正常运行。请注意，这些信息仅用于确保我们的应用能够在您的设备上正确运行，并且不会超出我们声明的收集目的。 </p>
        <p style="font-weight:600">在搜索框、编辑昵称或其他文本输入框中使用复制粘贴功能时，会读取您的剪切板信息。小蜜蜂兼职客户端会将粘贴的剪切板信息（或者您手动输入的内容），作为搜索关键词或者文本信息，上传至服务器，用于搜索、编辑昵称、客服文本消息、反馈申诉或其他文本输入框功能。剪切板信息属于该功能的非必须信息，若您不想提供，可以不使用输入框粘贴功能，但可以选择使用手动输入。</p>
        <p style="font-weight:600">您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息 （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）及/或日历、外部存储的访问权限、剪切板，以实现这些权限所涉及信息的收集和使用。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
        <p style="font-weight:600">关闭权限：您可以在“手机设置-应用设置-授权管理-应用权限管理-小蜜蜂兼职”关闭您需要取消授权的权限，设备信息等个人信息，您可以通过客服或者其他各种联系方式联系我们取消授权。</p>

        <p>·2.4 您充分知晓，在以下情形下我们收集、使用您的个人信息无需征得您的授权同意：</p>
        <p>·2.4.1 与国家安全、国防安全有关的；</p>
        <p>·2.4.2 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>·2.4.3 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>·2.4.4 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又难以得到本人同意的；</p>
        <p>·2.4.5 所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
        <p>·2.4.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>·2.4.7 根据您要求签订和履行合同所必需的；</p>
        <p>·2.4.8 用于维护所提供服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；</p>
        <p>·2.4.9 法律法规规定的其他情形。</p>
        <p>·2.5 根据法律规定，向第三方提供经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
        <h4>第三条 如何使用您的个人信息</h4>
        <p>·3.1 我们会根据本《隐私政策》的约定并为实现平台服务功能对所收集的个人信息进行使用。</p>
        <p>·3.2 请您注意，对于您在使用平台服务时所提供的所有个人信息，除非您删除或通过相关设置拒绝我们收集，否则您将在使用服务期间、账号注销前持续授权我们使用，在您注销账号后，我们将立即停止使用并删除您的个人信息。</p>
        <p>·3.3 若你提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</p>
        <p>·3.4 若我们将将收集的个人信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
        <p>·3.5 若我们从第三方处间接获取您的个人信息，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集，并向您告知共享的信息内容。涉及敏感信息的，在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺。如第三方有违反行为的，我们会明确要求对方承担相应法律责任，我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
        <p>·3.6 如我们平台停止运营，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除。</p>
        <h4>第四条 我们如何使用Cookie和同类技术</h4>
        <p>·4.1 Cookie</p>
        <p>·4.1.1 我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
        <p>·4.2 网站信标和像素标签</p>
        <p>·除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</p>
        <p>·4.3 Do Not Track（请勿追踪）</p>
        <p>·很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not Track，那么我们的所有网站都会尊重您的选择。</p>
        <p>·4.4 SDK（软件开发工具包）关于信息的收集及使用</p>
        <div style="font-weight:500">为保障「小蜜蜂兼职」相关功能的实现与应用安全稳定的运行，我们将根据实际业务场景需要，接入由第三方提供的软件开发包（SDK）实现相关目的。</div>
        <br />
        <div style="font-weight:500">我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。</div>
        <br />
        <div style="font-weight:500">我们对接入的相关第三方SDK在目录中列明。</div>
        <br />
        <div>请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公式的官方说明为准。</div>
        <p>·通过第三方SDK收集信息的情形小蜜蜂兼职的部分附加业务服务或功能，需要使用第三方SDK来协助完成，或者由第三方SDK来直接提供相关服务。这些SDK可能会收集或使用您的以下个人信息，我们会以弹窗或其他形式另行通知，在您授权同意后再获取相关信息。如未取得您的授权，我们将不会收集和使用相关信息，也不会再反复弹窗向您获取授权。目前这些SDK包括：</p>
        <p>4.4.1 SDK名称：<span style="font-weight:600">创蓝闪验 SDK</span></p>
        <p>所属机构：创蓝云智</p>
        <p>SDK用途：帮助实现用户一键登录行为</p>
        <p>SDK收集的个人信息类型：IP地址、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI），并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志</p>
        <p>官网链接：http://shanyan.253.com/</p>
        <p>隐私协议：https://www.mob.com/about/policy</p>
        <p>4.4.2 名称：<span style="font-weight:600"> Hyphenate-chat SDK</span> </p>
        <p> 所属机构：环信</p>
        <p> SDK用途：单聊、群聊、聊天室</p>
        <p> SDK收集的个人信息类型：用户ID、APPID（应用包名）、设备随机ID、设备硬件类型、设备型号、系统类型、SDK版本、设备网络类型</p>
        <p> 官网链接：https://www.easemob.com/</p>
        <p> 隐私政策：https://www.easemob.com/protocol</p>
        <p>4.4.3 SDK名称：<span style="font-weight:600">百度地图 SDK </span></p>
        <p> 所属机构：百度</p>
        <p> SDK用途：用于展示地图、附近兼职、兼职、企业距离和路线</p>
        <p> SDK收集的个人信息类型：设备信息【包括设备标识信息（Android ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、
位置信息【可能包括经纬度、GNSS信息、WiFi网关地址、WiFi MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、
网络类型【如移动网络、WiFi网络】、获取运行中进程信息</p>
        <p> 官网链接：https://lbsyun.baidu.com/</p>
        <p> 隐私政策：https://lbsyun.baidu.com/index.php?title=open/privacy</p>
        <p>4.4.4 SDK名称：<span style="font-weight:600">数美SDK (com.ishumei)</span></p>
        <p>所属机构：北京数美时代科技有限公司</p>
        <p>SDK用途：用于风险控制和反欺诈，以保障账户和交易安全</p>
        <p>SDK收集的个人信息类型：设备基本信息：设备品牌、设备制造商、设备型号、设备名称、设备系统类型及版本信息、设备基本配置、设备基本设置、设备环境、传感器信息（磁场、陀螺仪、加速度传感器）、SD卡信息 设备标识信息：MAC地址、AndroidID、IDFV（应用开发商标识符）、IDFA（广告标示符）、OAID（匿名设备标识符） 设备网络信息：网络的接入形式、无线路由器标识（BSSID、SSID）及IP地址、周边WIFI列表、网络运营商信息、网络基站信息、网络连接状态 设备应用信息：SDK宿主应用包名及版本号、运行中进程信息（仅获取当前进程名称）</p>
        <p>官网链接：https://www.ishumei.com/</p>
        <p> 隐私政策：https://www.ishumei.com/legal/cn/privacy.html</p>
        <p>4.4.5 SDK名称：<span style="font-weight:600">腾讯云即时通信 IM SDK</span></p>
        <p> 所属机构：腾讯</p>
        <p> SDK用途：单聊、群聊、聊天室</p>
        <p> SDK收集的个人信息类型：SDK收集的个人信息类型：网络连接状态、设备型号、系统版本</p>
        <p> 官网链接：https://cloud.tencent.com/product/im</p>
        <p> 隐私政策：https://cloud.tencent.com/document/product/269/58094</p>

        <p>4.4.6 SDK名称：<span style="font-weight:600">华为 PUSH SDK</span></p>
        <p> 所属机构：华为</p>
        <p> SDK用途：用于推送消息</p>
        <p> SDK收集的个人信息类型：设备标识信息</p>
        <p> 官网链接：https://developer.huawei.com/consumer/cn/hms/huawei-pushkit</p>
        <p> 隐私政策：https://consumer.huawei.com/cn/privacy/privacy-policy</p>

        <p>4.4.7 SDK名称：<span style="font-weight:600">华为推送服务 SDK</span></p>
        <p> 所属机构：华为</p>
        <p> SDK用途：用于消息推送基础服务</p>
        <p> SDK收集的个人信息类型：设备标识信息</p>
        <p> 官网链接：https://developer.huawei.com/consumer/cn/hms/huawei-pushkit</p>
        <p> 隐私政策：https://consumer.huawei.com/cn/privacy/privacy-policy</p>

        <p>4.4.8 SDK名称：<span style="font-weight:600"> 中国移动一键登录 SDK</span></p>
        <p> 所属机构：中国移动通信集团有限公司</p>
        <p> SDK用途：移动手机号码一键登录</p>
        <p> SDK收集的个人信息类型：网络类型（仅WiFi、仅数据流量、数据流量+WiFi）、网络制式（2G、3G、4G）、设备类型、系统、imsi、imei</p>
        <p> 隐私政策：https://wap.cmpassport.com/resources/html/contract.html</p>

        <p>4.4.9 SDK名称：<span style="font-weight:600"> 中国联通一键登录SDK</span></p>
        <p> 所属机构：中国联合网络通信集团有限公司</p>
        <p> SDK用途：联通手机号码一键登录</p>
        <p> SDK收集的个人信息类型：网络信息（私网IP）、手机信息（操作系统版本）</p>
        <p> 隐私政策：https://opencloud.wostore.cn/authz/resource/html/disclaimer.html</p>

        <p>4.4.10 SDK名称：<span style="font-weight:600"> 中国电信一键登录SDK</span></p>
        <p> 所属机构：中国电信集团有限公司</p>
        <p> SDK用途：电信手机号码一键登录</p>
        <p> SDK收集的个人信息类型：设备的ANDROID_ID、安装应用列表、手机设备型号、手机品牌厂商、手机操作系统版本、运营商类型、本地IP地址、网络连接类型、APP当前运行的进程</p>
        <p> 隐私政策：https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl=</p>

        <p>4.4.11 SDK名称：<span style="font-weight:600"> 小米 PUSH SDK</span></p>
        <p> 所属机构：小米科技有限责任公司</p>
        <p> SDK用途：在向用户推送通知或消息时使用</p>
        <p> SDK收集的个人信息类型：WIFI 信息、正在运行的应用列表、DeviceId（设备 ID）</p>
        <p> 隐私政策：https://dev.mi.com/console/doc/detail?pId=1822</p>

        <p>4.4.12 SDK名称：<span style="font-weight:600">OPPO PUSH SDK</span></p>
        <p> 所属机构：OPPO广东移动通信有限公司</p>
        <p> SDK用途：在向用户推送通知或消息时使用</p>
        <p> SDK收集的个人信息类型：网络类型、运营商类型</p>
        <p> 隐私政策：https://open.oppomobile.com/wiki/doc#id=10196</p>

        <p>4.4.13 SDK名称：<span style="font-weight:600">VIVO PUSH SDK</span></p>
        <p> 所属机构：维沃移动通信有限公司</p>
        <p> SDK用途：在向用户推送通知或消息时使用</p>
        <p> SDK收集的个人信息类型：正在运行的应用列表</p>
        <p> 隐私政策：https://dev.vivo.com.cn/documentCenter/doc/365</p>

        <p> 4.4.14 SDK名称：<span style="font-weight:600">热云数据SDK</span></p>
        <p> 所属机构：北京热云科技有限公司</p>
        <p> SDK用途：广告监测数据分析</p>
        <p> SDK收集的个人信息类型：iOS广告标识符（IDFA和IDFV）、安卓广告主标识符（Android ID）、网卡地址（MAC）、IP地址、国际移动设备识别码（IMEI）、移动设备识别码（MEID）、匿名设备标识码（OAID）、设备硬件信息、系统信息、运行环境信息、陀螺仪传感器</p>
        <p> 隐私政策：https://www.trackingio.com/#/policy</p>

        <p> 4.4.15 SDK名称：<span style="font-weight:600">移动推送SDK</span></p>
        <p> 所属机构：深圳市腾讯计算机系统有限公司</p>
        <p> SDK用途：在移动终端设备进行消息推送</p>
        <p> 收集个人信息类型：设备信息(手机型号，系统类型、系统版本等)用于标签化推送以及识别是否是真机、网络信息(网络类型)支持根据不同网络类型进行不同类型推送、账号绑定信息(根据您所选用的不同推送渠道，QQ号、微信Union ID、 手机号、邮箱等)用于根据账号信息进行推送，应用数据（推送流程中产生的送达、点击、曝光等数据）用于推送业务数据统计。</p>
        <p> 数据处理方式：通过去标识化、加密传输及其他安全方式</p>
        <p> 官网链接：https://cloud.tencent.com/product/tpns</p>
        <p> 隐私政策链接：https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727</p>

        <p> 4.4.16 SDK名称：<span style="font-weight:600">穿山甲SDK</span></p>
        <p> 所属机构：北京巨量引擎网络技术有限公司</p>
        <p> SDK用途：广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
        <p> 收集个人信息类型：设备信息(设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言等基础信息【仅Android】AndroidID、OAID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV可选信息：您可以基于广告投放效果优化的目的需要选择是否向穿山甲提供如下信息：【双端】无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址（如为iOS端，则仅适用于IOS3200以下版本）【仅Android】设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）) 应用信息(【仅Android】应用包名、运行中的进程信息、版本号、应用前后台状态可选信息：您可以基于广告投放效果优化的目的需要选择是否向穿山甲提供：【仅Android】软件列表信息) 传感器信息(【仅Android】加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器【仅iOS】加速度传感器、陀螺仪传感器)  广告信息(对广告的展示、点击及转化等交互数据) 位置信息 、性能数据 、 运营商信息、设备时区、sim卡信息</p>
        <p> 官网链接：https://www.csjplatform.com</p>
        <p> 隐私政策链接：https://www.csjplatform.com/privacy/partner</p>

        <h4>第五条 我们如何共享、转让、公开披露您的信息</h4>
        <p>·5.1 共享</p>
        <p>·我们将严格遵守法律法规，对您的个人信息予以保密，除以下情况除外，我们不会与平台提供者以外的公司、组织和个人共享您的个人信息：</p>
        <p>·5.1.1 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。您通过平台达成的交易，我们会根据您的选择，将与交易有关的必要信息共享给交易相对方，以实现您的交易及服务需求。如您点击报名某招聘企业的兼职、实习招聘、活动等，报名成功视为您明确同意，我们与该企业共享您的个人信息。</p>
        <p>·5.1.2 在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
        <p>·5.1.3 在法律法规允许的范围内，为维护您或其它用户的生命、财产安全等合法权益或是社会公共利益而有必要提供。</p>
        <p>·5.1.4 与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。如果我们共享您的个人敏感信息或关联公司改变个人信息的使用目的，将再次征求您的授权同意。</p>
        <p>·5.1.5 与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
        <p>·5.2 转让</p>
        <p>·5.2.1 我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>·5.2.2 事先获得您明确的同意或授权；</p>
        <p>·5.2.3 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求而必须进行提供；</p>
        <p>·5.2.4 根据与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定而提供；</p>
        <p>·5.2.5 我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
        <p>·5.3 公开披露</p>
        <p>·我们仅会在以下情况下，公开披露您的个人信息：</p>
        <p>·5.3.1 获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
        <p>·5.3.2 如果我们确定您出现违反法律法规或严重违反平台相关协议及规则的情况，或为保护平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息。</p>
        <p>·5.4 共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
        <p>·5.4.1 以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p>·a. 与国家安全、国防安全有关的；</p>
        <p>·b. 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>·c. 与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
        <p>·d. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p>·e. 您自行向社会公众公开的个人信息；</p>
        <p>·f. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p>·5.4.2 请知悉，根据适用的法律法规，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</p>
        <h4>第六条 我们如何保护您的个人信息</h4>
        <p>·6.1 我们非常重视个人信息安全，并采取一切合理可行的措施持续保护您的个人信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
        <p>·6.2 我们已采用符合行业标准的安全防护措施来保护您的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。</p>
        <p>·6.3 我们会采取合理可行的措施，尽力避免收集无关的个人信息，我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。</p>
        <p>·6.4 请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便我们竭尽所能加强安全措施，但也不可能始终保证信息百分之百的绝对安全。您需要了解和知悉，您接入平台服务所用的系统和通讯网络，有可能因我们可控范围外的其他因素而出现问题，在此情形下，我们会依法尽力协助解决。</p>
        <p>·6.5 如不幸发生信息安全事故，我们将按照法律法规的要求,及时向您告知：安全事件的基本情况和可能的影响、 我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议等。我们同时将及时将事件相关情况以邮件、信函、电话、 推送通知等适合的方式告知您；难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>
        <p>·6.6 在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息。</p>
        <p>·6.7 互联网并非绝对安全的环境，使用平台服务时，我们强烈建议您不要使用非本平台推荐的通信方式发送给您的信息。</p>
        <p>·6.8 在使用平台服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络平台客服，以便我们根据您的申请采取相应措施。</p>
        <p>·6.9 请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
        <p>·6.10 请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的所有信息的安全性。</p>
        <h4>第七条 我们如何保存您的个人信息</h4>
        <p>·7.1 保存期限</p>
        <p>·7.1.1 在您使用平台服务期间，我们将持续保存您的用户个人信息。</p>
        <p>·7.1.2 我们承诺始终按照法律的规定在合理必要期限内存储您个人信息，您的服务信息、交易信息保存时间为交易完成之日起三年。法律、行政法规另有规定的，依照其规定。</p>
        <p>·7.2 保存地域</p>
        <p>·7.2.1 您的个人信息将全部被存储于中华人民共和国境内。</p>
        <p>·7.2.2 目前我们不存在向境外提供个人信息的场景。</p>
        <h4>第八条 管理、查看或删除您的个人信息</h4>
        <p>·我们非常尊重您对自己的个人信息所享有的权利。我们保障您对个人信息所享有的访问、更正、删除、管理等权利。</p>
        <p>·8.1 访问和更正您的个人信息</p>
        <p>·8.1.1 除法律法规另有规定之外，您有权行使数据访问权。当您发现我们处理关于您的个人信息有错误或者您有其他修改、补充需求时， 您也有权要求我们或自行予以更正。如果您希望访问或修改您在平台上的账号信息，包括头像、姓名、性别、生日、职业、电话、微信、QQ等， 您可以通过访问我们的服务进行操作（可通过点击“我的”，进入个人主页后，点击“我的简历”功能后进行操作）。</p>
        <p>·8.1.2 在以下情形中，您可以向平台提出删除个人信息的请求：</p>
        <p>·a. 如果我们处理个人信息的行为违反相关的法律法规；</p>
        <p>·b. 如果我们收集、使用您的个人信息，却未征得您的同意；</p>
        <p>·c. 如果我们处理个人信息的行为违反了与您的约定或法律的规定；</p>
        <p>·d. 如果您不再使用平台服务，或者您注销了相关账号；</p>
        <p>·e. 如果我们不再为您提供产品及/或服务。</p>
        <p>·8.2 注销账号</p>
        <p>·8.2.1 您有权随时注销您在平台服务中注册的账号。为保障账号及财产安全，您可以进入“我的”---“帐号和安全”中进行帐号注销。</p>
        <p>·8.2.2 如果您想要注销您的个人账户，您的账户需同时满足以下条件：</p>
        <p>·a. 账户在平台系统中无资产、无欠款；</p>
        <p>·b. 账户内无未完成的兼职活动或招聘；</p>
        <p>·c. 账户无任何纠纷，包括投诉举报或被投诉举报；</p>
        <p>·d. 账户为正常使用中的账户且无任何被限制记录；</p>
        <p>·e. 账户对应的支付账户无任何被限制的记录，且已妥善处理了支付账户下的所有问题。</p>
        <p>·8.2.3 请您注意，注销平台账号是不可恢复的操作。在注销账号之后，我们将停止为您提供服务，并立即删除该账号项下的您的个人信息，您将无法再使用本平台账号，也无法找回您在本平台的与账户相关的任何内容或信息（包括您使用相同的手机号码再次注册并使用小蜜蜂兼职服务）。</p>
        <p>·8.3 在以下情形下，我们可能无法响应您的请求：</p>
        <p>·8.3.1 与国家安全、国防安全有关的；</p>
        <p>·8.3.2 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>·8.3.3 与犯罪侦查、起诉和审判等有关的；</p>
        <p>·8.3.4 有证据表明您存在主观恶意或滥用权利的；</p>
        <p>·8.3.5 响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</p>
        <p>·8.3.6 涉及商业秘密的。</p>
        <h4>第九条 我们如何处理未成年人的信息</h4>
        <p>·9.1在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
        <p>·9.2对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
        <h4>第十条 本政策如何更新</h4>
        <p>·10.1 我们的服务发生以下变化时，我们将及时对本《隐私权政策》进行相应的修订：</p>
        <p>·10.1.1 平台服务所涉业务功能发生变更，导致处理个人信息的目的、类型、使用方式发生变更；</p>
        <p>·10.1.2 您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>·10.1.3 我们负责处理您的个人信息安全的部门的联络方式发生变更；</p>
        <p>·10.1.4 发生其他可能影响用户个人信息安全或影响用户隐私权利的变更等。</p>
        <p>·10.2《隐私权政策》修订后平台服务相关界面发布最新版本并以弹窗、推送通知等合理的方式告知用户，以便用户及时了解《隐私权政策》的最新版本。</p>
        <p>·10.3 未经您的明确同意，我们不会削减您基于本《隐私政策》所享有的权利。</p>
        <p>·10.4 如无特殊说明，修订后的《隐私权政策》自公布之日起生效。</p>
        <h4>第十一条 投诉及建议</h4>
        <p>·我们已经建立投诉管理机制，如果您是兼职自然人，您可以在“我的”---“我的报名”---“岗位记录”中找到您已报名的交易记录，并点击拟投诉商户进入“报名单详情”，点击“投诉、举报”，或在“消息”中直接联系在线客服或直接拨打我们的客服电话4000882344进行投诉、举报，我们将在收到您的反馈后十五日内答复，若您对答复意见不满意，您可以再次通过客户服务进行申诉。</p>
        <h4>第十二条 法律文书送达地址确认</h4>
        <p>·12.1 您在此确认，司法机关（包括但不限于人民法院）可以手机短信或电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括诉讼文书）</p>
        <p>·12.2 您确认您同意邮寄地址为您身份证所示户口所在地，您在此确认本地址真实、有效、若本地址发生变更的，您应该及时通知平台。若您提供的送达地址不真实、不准确，或未及时向平台或司法机关告知变更后的地址，导致平台或司法机关向您发送的法律文书未被实际接收的，平台或司法机关以前述任一送达地址发出法律文书均视为送达，您应该承担由此产生的相应法律后果。</p>
        <h4>第十三条 如何联系我们</h4>
        <p>13.1 小蜜蜂兼职APP的经营者为湖北才优科技有限公司，若您在使用中遇到任何问题或对本隐私政策存在任何疑问，可通过以下方式联系我们。</p>
        <p>13.2 注册地址：湖北省武汉市武昌区丁字桥路99号2层1室（201）安稳众创空间2-11</p>
        <p>客服热线：4000882344</p>
        <h4>第十四条 其他</h4>
        <p>·14.1 如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向天津互联网法院提起诉讼来寻求解决方案。</p>
        <p>·14.2 在平台公布本《隐私权政策》或向您提供服务均视为本《隐私权政策》生效。平台停止运营或永久停止提供服务时本《隐私权政策》失效。</p>
    </div>
</template>

<script>

export default {
}
</script>

<style>
#app {
    font-size: 16px;
    line-height: 28px;
}
</style>
